/**
 * Detects if the page is in a same-origin iframe (e.g. dual view).
 * Returns false for cross-origin iframes (e.g. UseBerry user testing)
 * so that UI elements like the navbar remain visible.
 */
export const isInIframe = () => {
	if (window.self === window.top) {
		return false;
	}
	try {
		return !!window.parent.location.href;
	} catch {
		// Cross-origin iframe — not dual view
		return false;
	}
};
